// extracted by mini-css-extract-plugin
export var cardSelected = "_hx-2";
export var image = "_hx-1";
export var table = "_hx-0";